export const isInternalTrackingEnabled = () => {
  const value = process.env.REACT_APP_INTERNAL_TRACKING_ENABLED;

  if (value == null || value === '') {
    return true;
  }

  return value === 'true';
};

export const getInternalTrackingEndpoint = () => process.env.REACT_APP_INTERNAL_TRACKING_ENDPOINT;

export const getInternalTrackingApiKey = () => process.env.REACT_APP_INTERNAL_TRACKING_API_KEY;
